<template>
  <main class="loading-container">
    <section class="loading-container__info">
      <div class="loading-container__info__circle">
        <FileTextSvg />
      </div>
      <div class="circle-wrap"></div>
      <p class="loading-container__info__message">
        {{ currentMessage }}
      </p>
    </section>
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { admissionProcessFinishedMixin } from '@/utils/mixins';
import datalayerErrorMessage from '@/utils/helpers/message/datalayerErrorMessage.js';
import { ADMISSION_WITHOUT_VISIT } from '@/utils/constants/datalayerMessage.constants';

export default {
  name: 'PaymentPreLoading',

  mixins: [admissionProcessFinishedMixin],

  data: () => ({
    limitOfRetries: 21,
    timeOfRetries: 3000, // 3 seconds
    currentTime: 0,
    counter: () => {},
  }),
  computed: {
    ...mapGetters({
      isCollaboratorFlow: 'global/isCollaboratorFlow',
      isT2FlowAllowed: 'global/isT2FlowAllowed',
    }),
    currentMessage() {
      return this.isCollaboratorFlow
        ? 'Salvando dados para finalização...'
        : 'Salvando dados para pagamento...';
    },
  },

  methods: {
    ...mapActions(['getAdmissionById']),
    async startVisitFlow() {
      if (this.currentTime >= this.limitOfRetries) {
        return this.visitDoesntExistsOnAdmission();
      }

      if (this.limitOfRetries >= this.currentTime) {
        return this.checkVisitExistsOnAdmission();
      }
    },
    async startCheckInDoneFlow() {
      await this.admissionProcessFinished();

      this.startVisitFlowLoop();
    },
    async startVisitFlowLoop() {
      this.counter = setInterval(() => {
        if (this.currentTime >= this.limitOfRetries) {
          this.stopCounter();

          this.visitDoesntExistsOnAdmission();
        }

        this.startVisitFlow();
      }, this.timeOfRetries);
    },
    stopCounter() {
      clearInterval(this.counter);
    },
    async checkVisitExistsOnAdmission() {
      const admissionData = await this.getAdmissionById();

      if (admissionData?.visit) {
        return this.visitExistsOnAdmission();
      }

      this.currentTime = ++this.currentTime;

      return false;
    },
    async visitExistsOnAdmission() {
      if (this.isCollaboratorFlow) {
        return this.goNextStep('end_flow_success');
      }
      await this.goNextStep('payment_resume');
    },
    async visitDoesntExistsOnAdmission() {
      return await this.goNextStep(
        'irregular_insurance',
        datalayerErrorMessage('visitDoesntExistsOnAdmission', ADMISSION_WITHOUT_VISIT),
      );
    },
  },

  async created() {
    if (this.isCollaboratorFlow || this.isT2FlowAllowed) {
      this.startCheckInDoneFlow();
      return;
    }
    this.startVisitFlowLoop();
  },

  beforeDestroy() {
    this.stopCounter();
  },
};
</script>

<style lang="scss" scoped>
.loading-container {
  display: flex;
  padding: 24px;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  align-content: center;

  &__info {
    flex: 1;
    padding: 28px 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &__circle {
      margin: 16px 0;
      background-color: var(--color-slider-circle);
      width: 72px;
      height: 72px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      position: relative;

      &::after {
        content: '';
        width: 150%;
        height: 150%;
        background-image: conic-gradient(
          var(--color-slider) 120deg,
          var(--color-slider-circle) 90deg
        );
        border-radius: 50%;
        position: absolute;
        animation: rotate 2s linear infinite;
        z-index: 0;
      }

      &::before {
        content: '';
        width: 66px;
        height: 66px;
        background-color: var(--color-slider-circle);
        position: absolute;
        border-radius: 50%;
        z-index: 1;
      }

      svg {
        z-index: 2;

        path {
          fill: var(--color-slider);
        }
      }
    }

    &__message {
      font-family: 'Dasa sans', sans-serif;
      font-weight: var(--font-weight-bold);
      font-size: 20px;
      line-height: 24px;
      text-align: center;
      color: #161616b8;
    }
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>
